import { useState, useContext, useEffect } from "react"
import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"
import { PageNavbar } from "./page-navbar"
import { PageSidebar } from "./page-sidebar"
import { DebugSidebar } from "../DebugSidebar"
import { GlobalContext } from "../../context/Provider"
import { SECRET_KEY } from "../../constants/encriptKey"
import { getDecryptedDataFromSessionStorage } from "../../utils"
import { getUserRole } from "../../context/actions/auth/getUserRole";

const PageLayoutRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  paddingTop: 64,
  [theme.breakpoints.up("lg")]: open
    ? {
        paddingLeft: 280,
      }
    : {
        paddingLeft: 65,
      },
}))

export const PageLayout = (props) => {
  const { children } = props
  const { roleUser, setRoleUser } = useContext(GlobalContext)
  const [isSidebarOpen, setSidebarOpen] = useState(false)
  const [isSidebarPersistentOpen, setSidebarPersistentOpen] = useState(false)
  const decryptedData = getDecryptedDataFromSessionStorage(SECRET_KEY)

  useEffect(() => {
    const fetchDataAndLogin = async () => {
      try {
        if (!decryptedData) {
          console.error("❌ No hay datos de sesión disponibles");
          return;
        }
        const { id , accessToken } = decryptedData;
        if (!id || !accessToken) {
          console.error("❌ Faltan datos de sesión (id o accessToken)");
          return;
        }

        const response = await getUserRole({ idUsuario: id}, accessToken);
        
        const { result } = response;
        
        if (result?.idRol) {
          setRoleUser(result.idRol);
        } else {
          setRoleUser(1);
        }
      } catch (error) {
        // Establecer rol por defecto en caso de error para debugging
        setRoleUser(1);
      }
    }
    fetchDataAndLogin()
  }, [decryptedData, setRoleUser])

  return (
    <>
      <PageLayoutRoot open={isSidebarPersistentOpen}>
        <Box
          sx={{
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {children}
        </Box>
      </PageLayoutRoot>
      <PageNavbar
        onSidebarOpen={() => setSidebarOpen(true)}
        onSidebarPersistentOpen={() => setSidebarPersistentOpen(!isSidebarPersistentOpen)}
        openPersistent={isSidebarPersistentOpen}
      />
      <PageSidebar
        onClose={() => setSidebarOpen(false)}
        open={isSidebarOpen}
        openPersistent={isSidebarPersistentOpen}
        role={roleUser}
      />
      <DebugSidebar />
    </>
  )
}
